import React, { useEffect } from "react";
import Graph from '../../components/Graph';
import Table from 'react-bootstrap/Table';
import moment from 'moment';

const Occupancy = (props) => {
    const {
        options,
        assetName,
        counts,
        formatDate,
        avg_excluding_zeros,
        occup, 
        setOccupancy,
        occTbl, 
        setOccupancyTbl,
        chartColors
     } = props

    // VEHICLE COUNT START
    // --------------------------
    useEffect(() => {

        // Total vehicles count / hour
        const getOccupancy = () => {

        let arr = [];

        //Filter Vehicles OCCUPANCY. Exclude PEDESTRIANS
        for (let i = 0; i < counts.length; i++){

            const arrOcc = counts[i].entries
                .map(obj => {return { date_iso: counts[i].date_iso, OCCUPANCY: obj.OCCUPANCY, CLASS: obj.CLASS }})
                .filter(item => {return item.CLASS !== 'PEDESTRIAN' && item.CLASS !== 'BIKE' && item.OCCUPANCY !== 0 })

            let avg = {}
            if (arrOcc.length > 0)
                avg = {
                    date_iso: arrOcc[0].date_iso,
                    OCCUPANCY: avg_excluding_zeros(arrOcc.map(i => i.OCCUPANCY))
                } 

            // if (avg.OCCUPANCY)
            arr = [...arr, avg];
        }

        const aOcc = []
        for (let hh = 0; hh < 24; hh++){
            const item = arr.find(x => parseInt(moment(new Date(x.date_iso)).format('HH'))=== hh)

            aOcc.push({
                date_iso: (item && item.date_iso) || '',
                OCCUPANCY: (item && item.OCCUPANCY) || 0
            })
        }

        // Graph bar, 2 stacks: pedestrian and vehicle / hour
        const data = {
            labels: ['00:00-01:00','01:00-02:00','02:00-03:00','03:00-04:00','04:00-05:00','05:00-06:00'
                    ,'06:00-07:00','07:00-08:00','08:00-09:00','09:00-10:00','10:00-11:00','11:00-12:00'
                    ,'12:00-13:00','13:00-14:00','14:00-15:00','15:00-16:00','16:00-17:00','17:00-18:00'
                    ,'18:00-19:00','19:00-20:00','20:00-21:00','21:00-22:00','22:00-23:00','23:00-24:00'
                    ],
            datasets: [
            {
                label: 'Occupancy',
                data: aOcc.map(i => i.OCCUPANCY),
                borderColor: chartColors[10], //'rgba(75, 192, 192, 0.2)',
                backgroundColor: chartColors[10], //'rgba(75, 192, 192, 1)',
                borderWidth: 1,
                stack: '1'
            }]
        }
        setOccupancy(data);
        setOccupancyTbl(arr);
        }

        getOccupancy();
        // eslint-disable-next-line 
    },[counts, avg_excluding_zeros, setOccupancy, setOccupancyTbl]);
    // VEHICLE COUNT END

return (
    <div className="row p-2">
        <div className="col-md-12">
            <h2 className="text-header">Occupancy</h2>
            <div className="text-description small pb-3">
            relative zone occupancy in [%]
            </div>
            <div className="row">
                <div className="col-md-12">
                {(occup.datasets && occup.datasets.length > 0)?
                <Graph
                    title="Occupancy"
                    type="bar"
                    data={occup}
                    options={options}
                    site={assetName}
                />
                :''}
                </div>
                <div className="col-md-12 pt-3">
                    <Table responsive hover className="small p-0 border">
                    <thead>
                        <tr>
                        <th className="table-th-det">Date</th>
                        <th className="table-th-det">Time</th>
                        <th className="table-th-det">Occupancy [%]</th>
                        </tr>
                    </thead>
                    <tbody>

                    {occTbl.map((x, i) =>
                    (x.OCCUPANCY)?
                    <tr key={i} className="table-tr">
                        <td className="table-td">{ moment.utc(x.date_iso).local().format(formatDate[0])}</td>
                        <td className="table-td">{
                        parseInt(moment.utc(x.date_iso).local().format('HH'))+":00 - "
                        + (parseInt(moment.utc(x.date_iso).local().format('HH'))+1)+":00"
                        }</td>
                        <td className="table-td">{x.OCCUPANCY ? parseFloat(x.OCCUPANCY).toFixed(2) : '-'}</td>
                    </tr>
                    :<tr key={i} className="table-tr"></tr>
                    )}

                    </tbody>
                    </Table>
                </div>
            </div>
        </div>
    </div>
)}

export default Occupancy;